// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../css-loader/dist/cjs.js!perfect-scrollbar/css/perfect-scrollbar.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".ps-container{position:relative}", ""]);
// Exports
module.exports = exports;
